import { render, staticRenderFns } from "./GerenciarProvas.vue?vue&type=template&id=2d9c2a06&scoped=true&"
import script from "./GerenciarProvas.vue?vue&type=script&lang=js&"
export * from "./GerenciarProvas.vue?vue&type=script&lang=js&"
import style0 from "./GerenciarProvas.vue?vue&type=style&index=0&id=2d9c2a06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c2a06",
  null
  
)

export default component.exports